module.exports = __webpack_public_path__ + "./images/2a220cb51a33ecabf943609c1fb258ce.webp";